export default "__VITE_ASSET__CMh_vYfG__"